import { Component } from "react";
import InputTextElement from "./../InputTextElement";

export default class Input extends Component {
  constructor(props) {
    super(props);

    this.getComponent = this.getComponent.bind(this);
  }

  getComponent() {
    return this.component;
  }

  focus() {
    this.component && this.component.focus && this.component.focus();
  }

  blur() {
    this.component && this.component.blur && this.component.blur();
  }

  clearState = () => {
    this.component && this.component.clearState && this.component.clearState();
  };

  render() {
    return (
      <InputTextElement tagName="input" {...this.props} ref={c => (this.component = c)} />
    );
  }
}
